import type { FaireProductEntity } from "../../entity_types/product";

export const p_5apac36pj3: FaireProductEntity = {
  token: "p_5apac36pj3",
  type: "product",
  name: "Umbrella Shower Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1ddc33a9d20f212f60df389bcffe055280b6f3e921b4737fa9f03338fbe39caa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5062c175e35bcdea6875ad5997eaac23cc3024671b3dcca12a3a27d4adb0f01.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:48.119Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
